<template>
    <el-scrollbar
        tag="ul"
        :native="false"
        :class="['scrollbar-menu-box', boxClass]">
        <li v-for="(item, key) of menuList"
            :key="key"
            :class="{'is-hover': hoverMenu == item.id}"
            @mouseenter="hoverFun(item.id, item.child)">
            <router-link :style="{color: fontColor}"
                :to="{name: 'plist', query:{id:item.id}}">
                {{item.cat_name}}
            </router-link>
            <!-- 图标 -->
            <slot name="menuIcon"></slot>
        </li>
    </el-scrollbar>
</template>

<script>
    export default {
        props: {
            menuList: Array,
            boxClass: String,
            fontColor: String,
            hoverMenu: Number,
            hoverFun: Function,
        },
    }
</script>

<style scoped>
.scrollbar-menu-box li{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 20px;
    transition: all .1s linear; 
}
.scrollbar-menu-box .is-hover{
    background-color: #fe8729;
}
.scrollbar-menu-box .is-hover>a{
    color: #fff !important;
}
/* 标题 */
.scrollbar-menu-box li>a{
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>